import moment from 'moment';
import { POS_TYPE } from '../../constants';
import { capitalizeFirstLetter } from '../utils';
import { getLocalTime } from '../time/time';
import { isAVC } from '../user/userTenantCheck';

export { resolveMachineLocationDetails } from './resolveMachineLocationDetails';

export function shouldTakeMachinePhoto (machine, lastPhoto, tenantSettings, driver, serviceRunTime, tenantOverridableFieldValueGetter, tenant) {

	if (isAVC(tenant)) {
		return true;
	}

	const lastPhotoTime = lastPhoto?.created;

	// if no service run time is provided, use the local time of the tenant, set to 12 as it's the default time for the service run creator
	if (!serviceRunTime) {
		serviceRunTime = getLocalTime(tenant.timezone).set({ hour: 12, minute: 0, second: 0, millisecond: 0 });
	}

	const machineOverrideMachinePhotoSchedule = getFieldValue(machine, 'overrideMachinePhotoSchedule', tenantOverridableFieldValueGetter);

	// machin override
	if (machineOverrideMachinePhotoSchedule) {
		const machineRequireMachinePhotos = getFieldValue(machine, 'requireMachinePhotos', tenantOverridableFieldValueGetter);

		if (!machineRequireMachinePhotos) {
			return false;
		}

		const machineMachinesPhotosIntervalUnits = getFieldValue(machine, 'machinesPhotosIntervalUnits', tenantOverridableFieldValueGetter);
		const machineMachinesPhotosIntervalUnit = getFieldValue(machine, 'machinesPhotosIntervalUnit', tenantOverridableFieldValueGetter);

		return !lastPhotoTime || moment
			.utc(lastPhotoTime)
			.add(machineMachinesPhotosIntervalUnits, machineMachinesPhotosIntervalUnit)
			.isSameOrBefore(moment(serviceRunTime).utc(), 'days');
	}

	// market and machine photo schedules are splitted
	const posType = machine.type !== POS_TYPE.MARKET ? 'machine' : 'market';
	// driver override
	if (driver && driver[`override${capitalizeFirstLetter(posType)}PhotoSchedule`]) {
		if (!driver[`require${capitalizeFirstLetter(posType)}Photos`]) {
			return false;
		}

		return !lastPhotoTime || moment
			.utc(lastPhotoTime)
			.add(driver[`${posType}sPhotosIntervalUnits`], driver[`${posType}sPhotosIntervalUnit`])
			.isSameOrBefore(moment(serviceRunTime).utc(), 'days');
	}

	// use tenant settings
	if (!tenantSettings[`require${capitalizeFirstLetter(posType)}Photos`]) {
		return false;
	}

	return !lastPhotoTime || moment
		.utc(lastPhotoTime)
		.add(tenantSettings[`${posType}sPhotosIntervalUnits`], tenantSettings[`${posType}sPhotosIntervalUnit`])
		.isSameOrBefore(moment(serviceRunTime).utc(), 'days');
}

export function getFullMachineName (machine, place, location) {
	let name = '';

	// assetId
	if (machine?.assetId) {
		name = `${machine?.assetId}`;

		if (place?.name || location?.name) {
			name = `${name} @ `;
		}
	}

	// location name
	if (location?.name) {
		name = `${name}${location.name}`;

		if (place?.name) {
			name = `${name} / `;
		}
	}

	// place names
	if (place?.name) {
		name = `${name}${place.name}`;
	}

	return name;
}

function getFieldValue (document, field, tenantOverridableFieldValueGetter) {
	if (!tenantOverridableFieldValueGetter) {
		return document[field];
	}

	return tenantOverridableFieldValueGetter(document, field);
}
